import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { PrimaryButton } from "../../component/buttonComponent/ButtonComponent";
import "./NotFound.css";

export default function NotFound() {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            setUser(firebaseUser);
            setLoading(false);
        });

        return () => unsubscribe(); // Cleanup on unmount
    }, []);

    const handleRedirect = () => {
        navigate(user ? "/dashboard" : "/login");
    };

    return (
        <div className="not-found-container">
            <h1 className="not-found-title">Error 404</h1>
            <p className="not-found-message">Page Not Found</p>
            <div className="not-found-button-container">
                <PrimaryButton
                    width="15rem" 
                    label={user ? "Go to Dashboard" : "Go to Login"} 
                    onClickFunction={handleRedirect}
                    loading={loading}
                />
            </div>
        </div>
    );
}
